module.exports = __webpack_public_path__ + "static/media/kongQiArchitecture.1fe8f4dd.png";